import React from 'react';
// import axios from 'axios';
import { Button, message } from 'antd';
import SubTitle from '../SubTitle'
import PicturesWall from './PicturesWall'
import config from '../../dummy_data/configuration.json';
import {get, post, put, del} from '../../DAL/Request'
import PropTypes from "prop-types";

class AboutSetting  extends React.Component {
	static contextTypes = {
		router: PropTypes.object
	}
	
	constructor(props, context) {
	    super(props, context);
		this.state = {
			ID: 0,
			CompanyProfile: "",
			fileListA: [],
			fileListB: [],
			fileListC: [],
			fileListD: [],
			fileListE: [],
		}
	}

	componentDidMount() {
		this._refreshData();
	}


	_refreshData = () => {
  		get({
  			url: config.aboutAction, 
  			history: this.context.router.history,
  			callback: (res) => {
  				this.setState({
            	ID: res.data.ID,
            	CompanyProfile: res.data.CompanyProfile
				});
	            if(res.data.ImageA){
	            	this.setState({
	            		fileListA: [{
				      	uid: -1,
				      	name: res.data.ImageA.substr(res.data.ImageA.lastIndexOf('/')+1),
				      	status: 'done',
						url: config.rootSite + res.data.ImageA
					    }]
					});
	            }
	            if(res.data.ImageB){
	            	this.setState({
	            		fileListB: [{
				      	uid: -1,
				      	name: res.data.ImageB.substr(res.data.ImageB.lastIndexOf('/')+1),
				      	status: 'done',
						url: config.rootSite +  res.data.ImageB
					    }]
					});
	            }
	            if(res.data.ImageC){
	            	this.setState({
	            		fileListC: [{
				      	uid: -1,
				      	name: res.data.ImageC.substr(res.data.ImageC.lastIndexOf('/')+1),
				      	status: 'done',
						url: config.rootSite +  res.data.ImageC
					    }]
					});
	            }
	            if(res.data.ImageD){
	            	this.setState({
	            		fileListD: [{
				      	uid: -1,
				      	name: res.data.ImageD.substr(res.data.ImageD.lastIndexOf('/')+1),
				      	status: 'done',
						url: config.rootSite +  res.data.ImageD
					    }]
					});
	            }
	            if(res.data.ImageE){
	            	this.setState({
	            		fileListE: [{
				      	uid: -1,
				      	name: res.data.ImageE.substr(res.data.ImageE.lastIndexOf('/')+1),
				      	status: 'done',
						url: config.rootSite +  res.data.ImageE
					    }]
					});
	            }
  			}
  		});
	}

	handleTextChange = (event) => {
		this.setState({
	      CompanyProfile: event.target.value
	    });
	}

	handleImageChangeA = ({ fileList }) => {
		if(fileList.length > 0){
			fileList[0].url = fileList[0].response;
		}
		this.setState({ fileListA: fileList });
	}
	handleImageChangeB = ({ fileList }) => {
		if(fileList.length > 0){
			fileList[0].url = fileList[0].response;
		}
		this.setState({ fileListB: fileList });
	}
	handleImageChangeC = ({ fileList }) => {
		if(fileList.length > 0){
			fileList[0].url = fileList[0].response;
		}
		this.setState({ fileListC: fileList });
	}
	handleImageChangeD = ({ fileList }) => {
		if(fileList.length > 0){
			fileList[0].url = fileList[0].response;
		}
		this.setState({ fileListD: fileList });
	}
	handleImageChangeE = ({ fileList }) => {
		if(fileList.length > 0){
			fileList[0].url = fileList[0].response;
		}
		this.setState({ fileListE: fileList });
	}

	handleSubmit = () => {
		console.log(this.state);

		let formData = {
			ID: this.state.ID,
			CompanyProfile: this.state.CompanyProfile
		};
		if(this.state.fileListA.length > 0){
			formData.ImageA = this.state.fileListA[0].url.replace(config.rootSite, '');
		}
		if(this.state.fileListB.length > 0){
			formData.ImageB = this.state.fileListB[0].url.replace(config.rootSite, '');
		}
		if(this.state.fileListC.length > 0){
			formData.ImageC = this.state.fileListC[0].url.replace(config.rootSite, '');
		}
		if(this.state.fileListD.length > 0){
			formData.ImageD = this.state.fileListD[0].url.replace(config.rootSite, '');
		}
		if(this.state.fileListE.length > 0){
			formData.ImageE = this.state.fileListE[0].url.replace(config.rootSite, '');
		}

		// axios({
		// 	method: 'put',
		// 	url: config.aboutAction,
		// 	responseType:'json',
		// 	data: formData
		// }).then(res => {
		// 	console.log("response", res);
		// }).catch(function (error) {
		// 	console.log(error);
		// });
		put({
  			url: config.aboutAction, 
  			history: this.context.router.history,
  			body: formData,
  			callback: (res) => {
  				console.log("response", res);
  				message.info('Succeeded');
  			}
  		});
	}



	render() {
		//console.log(this.state);
		return (
			<div className="block-content">
				<SubTitle title="ABOUT" />
		      	<div className="about-setting">
		      		<div className="about-setting-left">
		      			<PicturesWall previewWidth={1200} fileList={this.state.fileListA} uploadAction={config.imageUploadAction} handleImageChange={this.handleImageChangeA}/>
		      			<textarea className="" placeholder="Description about OWM" onChange={this.handleTextChange} value={this.state.CompanyProfile}></textarea>
		      		</div>
		      		<div className="about-setting-right">
			      		<div className="about-setting-right-item">	      			
			      			<PicturesWall fileList={this.state.fileListB} uploadAction={config.imageUploadAction} handleImageChange={this.handleImageChangeB}/>
			      			<PicturesWall fileList={this.state.fileListC} uploadAction={config.imageUploadAction} handleImageChange={this.handleImageChangeC}/>
			      		</div>
			      		<div className="about-setting-right-item">
			      			<PicturesWall fileList={this.state.fileListD} uploadAction={config.imageUploadAction} handleImageChange={this.handleImageChangeD}/>
			      			<PicturesWall fileList={this.state.fileListE} uploadAction={config.imageUploadAction} handleImageChange={this.handleImageChangeE}/>
			      		</div>
		      		</div>
		      	</div>
		      	<div className="about-setting-operation">
		            <Button key="submit" type="primary" loading={this.state.loading} onClick={this.handleSubmit}>
		              	Submit
		            </Button>
	      		</div>
			</div>
		);
	}
	
}

export default AboutSetting;


// WEBPACK FOOTER //
// ./src/components/admin/AboutSetting.js